"use client";

import { useRouter } from "next/navigation";
import { FC, ReactNode, useEffect, useState } from "react";

import { Wrapper as Wrapper_ } from "@/components/common/wrapper.styled";
import { Background } from "@/components/trade/trade.styled";
import { useRx } from "@/contexts/rx";
import type { BgType } from "@/types/common";

import { checkIsWatch } from "../../util/position-helpers";
import TradeContext from "./context";
import { useChainData } from "./hooks/data";
import useTradeState from "./state";

const Wrapper: FC<{
  address?: `0x${string}`;
  chainName: string;
  children: ReactNode;
  cn?: string;
}> = ({ address, children, chainName, cn }) => {
  const { replace } = useRouter();
  const [className, setClassName] = useState<BgType>();
  const { navState$ } = useRx();
  const [state, dispatch] = useTradeState();
  const chainData = useChainData(address);

  useEffect(() => {
    const sub = navState$.subscribe((state) => {
      setClassName(state.bgType);
    });

    return () => {
      sub.unsubscribe();
    };
  }, [navState$]);

  if (checkIsWatch(chainData.type)) {
    replace(`/${chainName}/watch-position/${address}`);
  }

  return (
    <Background className={className}>
      <Wrapper_ className={`wrapper--trade ` + cn ?? ""}>
        <TradeContext.Provider
          value={{ ...state, ...chainData, address, dispatch }}
        >
          {children}
        </TradeContext.Provider>
      </Wrapper_>
    </Background>
  );
};

export default Wrapper;
